// 基础面试信息接口
export interface InterviewBase {
  stage: InterviewStage;
  dateTime: string;
  duration?: number | null;
  location?: string | null;
  interviewer?: string | null;
  notes?: string | null;
  feedback?: string | null;
  status?: InterviewStatus | null;
  preparationMaterials?: string | null;
  createTime?: string;
  updateTime?: string;
  jobPosition?: any | null;
}

// 创建面试时的接口，必须包含positionId
export interface CreateInterview extends InterviewBase {
  positionId: number;
}

// 更新面试时的接口，必须包含id但不需要positionId
export interface UpdateInterview extends Partial<InterviewBase> {
  id: number;
}

// 完整的面试信息接口，用于展示
export interface Interview extends InterviewBase {
  id?: number;
  positionId: number;
}

export type InterviewStage = 
  | 'not_started'    // 未开始
  | 'online_test'    // 在线测试
  | 'first_round'    // 第一轮
  | 'second_round'   // 第二轮
  | 'final_round'    // 终面
  | 'hr_round'       // HR面
  | 'completed';     // 已完成

export type InterviewStatus = 
  | 'pending'
  | 'completed'
  | 'cancelled'
  | 'rescheduled'
  | 'no_show';

export const INTERVIEW_STAGES: { [key in InterviewStage]: string } = {
  not_started: '待面试',
  online_test: '在线测试',
  first_round: '第一轮',
  second_round: '第二轮',
  final_round: '终面',
  hr_round: 'HR面',
  completed: '已完成'
};

export const INTERVIEW_STATUS: { [key in InterviewStatus]: string } = {
  pending: '待进行',
  completed: '已完成',
  cancelled: '已取消',
  rescheduled: '已改期',
  no_show: '未出席'
}; 